
// export const languages=["Hindi", "Bengali", "Telugu", "Marathi", "Tamil", "Urdu", "Gujarati", "Kannada", "Punjabi", "Malayalam", "Odia", "Assamese", "Bhojpuri", "Haryanvi", "Rajasthani", "Sindhi", "Konkani", "Manipuri", "Maithili", "Santali", "Kashmiri", "Nepali", "Dogri", "Kokborok", "Khasi", "Mizo (Lushai)", "Tulu", "Garhwali", "Kumaoni", "Bhili","English", "Spanish", "French", "German", "Italian", "Portuguese", "Chinese" , "Japanese", "Korean", "Russian"]
export const languages = ['Assamese','Bengali','Bhili','Bhojpuri','Dogri','Garhwali','Gujarati','Haryanvi','Hindi','Kannada','Kashmiri','Khasi','Kokborok','Konkani','Kumaoni','Maithili','Malayalam','Manipuri','Marathi','Mizo','Nepali','Odia','Punjabi','Rajasthani','Santali','Sindhi','Tamil','Telugu','Tulu','Urdu','English','Spanish','French','German','Italian','Portuguese','Chinese','Japanese','Korean','Russian','Any Other'];


export const artform =  [
  "Classical",
  "Folk",
  "etc"
  // "Solo Act", "Band/Group", "Dance Crew", "Theatre/Play", "Comedy", "Magic/Illusion",
  // "Circus/Street Performance", "Visual Arts", "Fire/Danger Acts", "Variety Show",
  // "Interactive/Immersive", "Folk/Cultural", "Digital/Technology", "Poetry/Spoken Word", "Performance Art"
];

export const specialization =[
 
  "Classical Dance Forms", "Traditional Music", "Comedy / stand up comedy", "Traditional Crafts and Handicrafts", "Storytelling", "Folk arts and Culinary Arts", "singing", "dancing", "acting"

]

export const performancetype=[
  "Both" ,
"Professional",
"Traditional"  ,
"None"
  // "Solo Act", "Band/Group", "Dance Crew", "Theatre/Play", "Comedy", "Magic/Illusion", "Circus/Street Performance", "Visual Arts", "Fire/Danger Acts", "Variety Show", "Interactive/Immersive", "Folk/Cultural", "Digital/Technology", "Poetry/Spoken Word", "Performance Art"
]

export const natureofArt=["Dance","Song","Music","Theatre","Any Other"]

export const nameofart=["Bharatanatyam", "Kathak", "Odissi", "Kathakali", "Manipuri", "Mohiniyattam", "Bhangra", "Garba", "Dandiya Raas", "Lavani", "Kuchipudi", "Sattriya", "Chhau", "Giddha", "Yakshagana", "Bihu", "Rauf", "Kalbelia", "Gotipua"
]

 export const courses=["Madhubani", "Tanjore", "Warli", "Miniature Painting", "Clay Modeling", "Stone Carving", "Wood Carving", "Bharatanatyam", "Kathak", "Odissi", "Classical Music", "Pottery", "Embroidery", "Weaving", "Block Printing", "Sitar", "Tabla", "Flute", "Veena"
]
export const highestLevelOfPerformance=["International", "National", "State", "District", "Taluka", "Local", "Others"]

export const performanceduration=[
  // "½ hour", "1 hour", "1½ hours", "2 hours", "2½ hours", "3 hours", "3½ hours", "4 hours", "4½ hours", "5 hours"
"Below 15 min","15-30 min","30-45 min","45-60 min","1-1.5 hours","1.5-2 hours","More the 2 hours"
]

export const ChargesPerPerformance=["5000", "10000", "15000", "20000", "25000", "30000", "35000", "40000", "45000", "50000"]

export const typeOfArt = ["Classical","Folk","Fusion","Any Other"]

export const artInfo1=[
  {
    art:"Dance",
    category:[
      {
        type:"Bharatanatyam"
      },
      {
        type:"Bihu"
      },
      {
        type:"Chhau"
      },
      {
        type:"Dandiya Raas"
      },
      {
        type:"Dollu Kunitha"
      },
      {
        type:"Dumhal"
      },
      {
        type:"Garba"
      },
      {
        type:"Gaur Dance"
      },
      {
        type:"Giddha"
      },
      {
        type:"Gotipua"
      },
      {
        type:"Jhumar"
      },
      {
        type:"Kacchi Ghodi"
      },
      {
        type:"Kalbelia"
      },
      {
        type:"Karakattam"
      },
      {
        type:"Kathak"
      },
      {
        type:"Kathakali"
      },
      {
        type:"Kathakar"
      },
      {
        type:"Koli"
      },
      {
        type:"Kuchipudi"
      },
       {
        type:"Lavani"
      },
      {
        type:"Manipuri"
      },
      {
        type:"Mayurbhanj Chhau"
      },
      {
        type:"Mohiniyattam"
      },
      {
        type:"Odissi"
      },
      {
        type:"Raas Leela"
      },
      {
        type:"Sattriya"
      },
      {
        type:"Tamasha"
      },
      {
        type:"Tera Tali"
      },
      {
        type:"Thang-Ta"
      },
      {
        type:"Yakshagana"
      }
    ]

  },
  {
    art:"Song",
    category:[
      {
        type:"Dhrupad"
      },
      {
        type:"Khayal"
      },
      {
        type:"Thumri"
      },
      {
        type:"Tappa"
      },
      {
        type:"Ghazal"
      },
      {
        type:"Qawwali"
      },
      {
        type:"Kriti"
      },
      {
        type:"Varnam"
      },
      {
        type:"Tillana"
      },
      {
        type:"Ragamalika"
      },
      {
        type:"Javali"
      },
      {
        type:"Swarajati"
      },
      {
        type:"Bhajans"
      },
      {
        type:"Kirtan"
      },
      {
        type:"Sufi Music"
      },
      {
        type:"Abhangas"
      },
      {
        type:"Shabad Kirtan (Sikh)"
      }
    ]
  },
  {
    art:"Music",
    category:[
      {
        type:"Bansuri"
      },
      {
        type:"Dilruba"
      },
      {
        type:"Dholak"
      },
      {
        type:"Ektara"
      },
      {
        type:"Esraj"
      },
      {
        type:"Flute (Bansuri)"
      },
      {
        type:"Ghatam"
      },
      {
        type:"Harmonium"
      },
      {
        type:"Jal Tarang"
      },
      {
        type:"Mridangam"
      },
      {
        type:"Nadaswaram"
      },
      {
        type:"Pakhawaj"
      },
      {
        type:"Ravanahatha"
      },
      {
        type:"Ravanahatha"
      },
      {
        type:"Sarangi"
      },
      {
        type:"Sarod"
      },
      
      {
        type:"Santoor"
      },
      {
        type:"Shehnai"
      },
      {
        type:"Sitar"
      },
      {
        type:"Tabla"
      },
      {
        type:"Tanpura"
      },
      {
        type:"Tumbi"
      },
      {
        type:"Veena"
      },
    ]
  },
  {
    art:"Theatre",
    category:[
      {
        type:"Bhavai"
      },
      {
        type:"Bhand Pather"
      },
      {
        type:"Jatra"
      },
      {
        type:"Koodiyattam"
      },
      {
        type:"Mudiyettu"
      },
      {
        type:"Nautanki"
      },
      {
        type:"Pandavani"
      },
      {
        type:"Pothu Koothu"
      },
      {
        type:"Ramlila"
      },
      {
        type:"Ram Lila"
      },
      {
        type:"Ras Leela"
      },
      {
        type:"Sattriya"
      },
      {
        type:"Tamaasha"
      },
      {
        type:"Therukoothu"
      },
      {
        type:"Yakshagana"
      }
    ]
  },
    {
    art:"Any Other",
  
    category:[]
  }
]


export const indian_cities = [
  "Agra",
  "Ahmedabad",
  "Ahmedabad",
  "Amritsar",
  "Bengaluru",
  "Bhopal",
  "Bhubaneswar",
  "Chandigarh",
  "Chennai",
  "Coimbatore",
  "Dhanbad",
  "Dehradun",
  "Durgapur",
  "Gwalior",
  "Hyderabad",
  "Indore",
  "Jaipur",
  "Jamshedpur",
  "Jabalpur",
  "Jodhpur",
  "Kanpur",
  "Kochi",
  "Kolkata",
  "Kollam",
  "Kota",
  "Kozhikode",
  "Lucknow",
  "Ludhiana",
  "Madurai",
  "Mangaluru",
  "Mumbai",
  "Muzaffarpur",
  "Mysuru",
  "Nagpur",
  "Nashik",
  "Pali",
  "Patna",
  "Puducherry",
  "Pune",
  "Raipur",
  "Ranchi",
  "Shimla",
  "Surat",
  "Thane",
  "Thiruvananthapuram",
  "Tiruppur",
  "Udaipur",
  "Varanasi",
  "Vadodara",
  "Visakhapatnam"
];

const indian_state = ["Nicobar", "North Middle Andaman", "South Andaman", "Anantapur", "Chittoor", "East Godavari", "Alluri Sitarama Raju", "Anakapalli", "Annamaya", "Bapatla", "Eluru", "Guntur", "Kadapa", "Kakinada", "Konaseema", "Krishna", "Kurnool", "Manyam", "N T Rama Rao", "Nandyal", "Nellore", "Palnadu", "Prakasam", "Sri Balaji", "Sri Satya Sai", "Srikakulam", "Visakhapatnam", "Vizianagaram", "West Godavari", "Anjaw", "Changlang", "Dibang Valley", "East Kameng", "East Siang", "Kamle", "Kra Daadi", "Kurung Kumey", "Lepa Rada", "Lohit", "Longding", "Lower Dibang Valley", "Lower Siang", "Lower Subansiri", "Namsai", "Pakke Kessang", "Papum Pare", "Shi Yomi", "Siang", "Tawang", "Tirap", "Upper Siang", "Upper Subansiri", "West Kameng", "West Siang", "Baksa", "Barpeta", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Dima Hasao", "Goalpara", "Golaghat", "Hailakandi", "Jorhat", "Kamrup Metropolitan", "Kamrup Rural", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Sivasagar", "Sonitpur", "South Salmara-Mankachar", "Tinsukia", "Udalguri", "West Karbi Anglong", "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran", "Chandigarh", "Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur", "Dantewada", "Dhamtari", "Durg", "Gariaband", "Gaurela Pendra Marwahi", "Janjgir Champa", "Jashpur", "Kabirdham", "Kanker", "Khairagarh", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Manendragarh", "Mohla Manpur", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Sakti", "Sarangarh Bilaigarh", "Sukma", "Surajpur", "Surguja", "Dadra and Nagar Haveli", "Daman", "Diu", "Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi", "North West Delhi", "Shahdara", "South Delhi", "South East Delhi", "South West Delhi", "West Delhi", "North Goa", "South Goa", "Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari", "Panchmahal", "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar", "Tapi", "Vadodara", "Valsad", "Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh", "Nuh", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar", "Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una", "Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur", "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa", "Giridih"];
//export const indian_states = ["Nicobar", "North Middle Andaman", "South Andaman", "Anantapur", "Chittoor", "East Godavari", "Alluri Sitarama Raju", "Anakapalli", "Annamaya", "Bapatla", "Eluru", "Guntur", "Kadapa", "Kakinada", "Konaseema", "Krishna", "Kurnool", "Manyam", "N T Rama Rao", "Nandyal", "Nellore", "Palnadu", "Prakasam", "Sri Balaji", "Sri Satya Sai", "Srikakulam", "Visakhapatnam", "Vizianagaram", "West Godavari", "Anjaw", "Changlang", "Dibang Valley", "East Kameng", "East Siang", "Kamle", "Kra Daadi", "Kurung Kumey", "Lepa Rada", "Lohit", "Longding", "Lower Dibang Valley", "Lower Siang", "Lower Subansiri", "Namsai", "Pakke Kessang", "Papum Pare", "Shi Yomi", "Siang", "Tawang", "Tirap", "Upper Siang", "Upper Subansiri", "West Kameng", "West Siang", "Baksa", "Barpeta", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Dima Hasao", "Goalpara", "Golaghat", "Hailakandi", "Jorhat", "Kamrup Metropolitan", "Kamrup Rural", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Sivasagar", "Sonitpur", "South Salmara-Mankachar", "Tinsukia", "Udalguri", "West Karbi Anglong", "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran", "Chandigarh", "Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur", "Dantewada", "Dhamtari", "Durg", "Gariaband", "Gaurela Pendra Marwahi", "Janjgir Champa", "Jashpur", "Kabirdham", "Kanker", "Khairagarh", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Manendragarh", "Mohla Manpur", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Sakti", "Sarangarh Bilaigarh", "Sukma", "Surajpur", "Surguja", "Dadra and Nagar Haveli", "Daman", "Diu", "Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi", "North West Delhi", "Shahdara", "South Delhi", "South East Delhi", "South West Delhi", "West Delhi", "North Goa", "South Goa", "Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari", "Panchmahal", "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar", "Tapi", "Vadodara", "Valsad", "Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh", "Nuh", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar", "Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una", "Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur", "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa", "Giridih"];

export const indian_states = 
[
  "Adilabad",
"Agar Malwa",
"Agra",
"Ahmedabad",
"Ahmednagar",
"Aizawl",
"Ajmer",
"Akola",
"Alappuzha",
"Aligarh",
"Alipurduar",
"Alirajpur",
"Allahabad ",
"Almora",
"Ambedkar Nagar",
"Amravati",
"Amreli",
"Amritsar",
"Anand",
"Anantapur",
"Anantnag",
"Araria",
"Aravalli",
"Ariyalur",
"Ashoknagar",
"Aurangabad",
"Aurangabad",
"Ayodhya",
"Azamgarh",
"Bagalkot",
"Baghpat",
"Bahraich",
"Balangir",
"Balasore",
"Ballia",
"Baloda Bazar",
"Balrampur",
"Banaskantha",
"Banda",
"Bandipora",
"Bangalore Rural",
"Bangalore Urban",
"Banka",
"Bankura",
"Baramulla",
"Baran",
"Bardhaman",
"Bareilly",
"Barnala",
"Barpeta",
"Barwani",
"Bastar",
"Bathinda",
"Beawar",
"Begusarai",
"Belgaum",
"Bellary",
"Betul",
"Bhadrak",
"Bhadradri Kothagudem",
"Bhagalpur",
"Bhandara",
"Bharatpur",
"Bharuch",
"Bhavnagar",
"Bhilwara",
"Bhopal",
"Bidar",
"Bijnor",
"Bikaner",
"Bilaspur",
"Bilaspur",
"Birbhum",
"Bishnupur",
"Bokaro",
"Bongaigaon",
"Botad",
"Boudh",
"Budaun",
"Budgam",
"Bulandshahr",
"Bundi",
"Burhanpur",
"Chachaura",
"Chamarajanagar",
"Chamoli",
"Champawat",
"Champhai",
"Chandauli",
"Chandel",
"Chandigarh",
"Chandrapur",
"Changlang",
"Chatra",
"Chennai",
"Chengalpattu",
"Chhatarpur",
"Chhindwara",
"Chhota Udaipur",
"Chirang",
"Chitradurga",
"Chittoor",
"Chittorgarh",
"Churu",
"Coimbatore",
"Cooch Behar",
"Cuddalore",
"Cuttack",
"Dadra and Nagar Haveli",
"Dahod",
"Dakshina Kannada",
"Dakshin Dinajpur",
"Daman",
"Damoh",
"Dantewada",
"Darbhanga",
"Darjeeling",
"Darrang",
"Datia",
"Dausa",
"Davanagere",
"Debagarh",
"Deeg",
"Dehradun",
"Delhi",
"Dhanbad",
"Dhar",
"Dharmapuri",
"Dhaulpur",
"Dhemaji",
"Dholpur",
"Dhubri",
"Dibrugarh",
"Dima Hasao",
"Dimapur",
"Dindigul",
"Dindori",
"Diu",
"Doda",
"Dudu",
"Dungarpur",
"East Champaran",
"East Delhi",
"East Garo Hills",
"East Jaintia Hills",
"East Kameng",
"East Khasi Hills",
"East Siang",
"Eluru",
"Ernakulam",
"Etah",
"Etawah",
"Faizabad",
"Faridabad",
"Faridkot",
"Fatehabad",
"Fatehpur",
"Fazilka",
"Ferozabad",
"Firozabad",
"Firozpur",
"Gadag",
"Gadchiroli",
"Gajapati",
"Gandhinagar",
"Ganjam",
"Ganderbal",
"Ganga",
"Gangapur City",
"Gautam Buddha Nagar",
"Gaya",
"Gazipur",
"Ghaziabad",
"Ghazipur",
"Gir Somnath",
"Giridih",
"Goalpara",
"Gomati",
"Gorakhpur",
"Guna",
"Guntur",
"Gurugram",
"Gwalior",
"Hailakandi",
"Hamirpur",
"Hamirpur",
"Hanamkonda",
"Hanumangarh",
"Harda",
"Hardoi",
"Haridwar",
"Hassan",
"Hathras",
"Haveri",
"Hazaribagh",
"Hingoli",
"Hnahthial",
"Hooghly",
"Hoshiarpur",
"Howrah",
"Idukki",
"Imphal East",
"Imphal West",
"Indore",
"Jabalpur",
"Jagatsinghpur",
"Jaintia Hills",
"Jaipur",
"Jaipur Rural",
"Jaisalmer",
"Jajpur",
"Jalandhar",
"Jalgaon",
"Jalna",
"Jalpaiguri",
"Jammu",
"Jamnagar",
"Jamtara",
"Janjgir Champa",
"Jashpur",
"Jaunpur",
"Jehanabad",
"Jhajjar",
"Jhalawar",
"Jhansi",
"Jhargram",
"Jharsuguda",
"Jiribam",
"Jiribam",
"Jogulamba",
"Jorhat",
"Junagadh",
"Kabirdham",
"Kachchh",
"Kaimur",
"Kamareddy",
"Kamjong",
"Kamle",
"Kamrup Metropolitan",
"Kamrup Rural",
"Kanauj",
"Kanchipuram",
"Kandhamal",
"Kangpokpi",
"Kannauj",
"Kannur",
"Kanpur Dehat",
"Kanpur Nagar",
"Kanyakumari",
"Kapurthala",
"Karaikal",
"Karauli",
"Kargil",
"Karimganj",
"Karimnagar",
"Kasganj",
"Katakwi",
"Katihar",
"Katni",
"Kavaratti",
"Kawardha",
"Keelakarai",
"Kendrapara",
"Kendujhar",
"Kepil",
"Khagaria",
"Khairagarh",
"Khairthal Tijara",
"Khammam",
"Khargone",
"Kheda",
"Khowai",
"Khunti",
"Kinnaur",
"Kiphire",
"Kishtwar",
"Kodagu",
"Koderma",
"Kohima",
"Kokrajhar",
"Kolar",
"Kolasib",
"Kolhapur",
"Kolkata",
"Kollam",
"Kota",
"Kotputli Behror",
"Kottayam",
"Kozhikode",
"Krishnagiri",
"Kullu",
"Kupwara",
"Kurukshetra",
"Lakhimpur",
"Lakhimpur Kheri",
"Lakshadweep",
"Lalitpur",
"Latehar",
"Latur",
"Lawngtlai",
"Leh",
"Lepa Rada",
"Lohardaga",
"Lohit",
"Longding",
"Lucknow",
"Ludhiana",
"Madhepura",
"Madhubani",
"Madurai",
"Mahabubabad",
"Mahasamund",
"Maharajganj",
"Mahbubnagar",
"Mainpuri",
"Majuli",
"Malappuram",
"Malkangiri",
"Malda",
"Mamit",
"Mancherial",
"Mandi",
"Mandla",
"Mansa",
"Mau",
"Mayiladuthurai",
"Meerut",
"Mahendragarh",
"Mehsana",
"Mirzapur",
"Moga",
"Mohali",
"Mokokchung",
"Mon",
"Moradabad",
"Morena",
"Morigaon",
"Muktsar",
"Mumbai City",
"Mumbai Suburban",
"Mungeli",
"Munger",
"Murshidabad",
"Muzaffarpur",
"Muzaffarnagar",
"Mysore",
"Nagapattinam",
"Nagaon",
"Nagarkurnool",
"Nainital",
"Nalanda",
"Nalbari",
"Nalgonda",
"Namsai",
"Nanded",
"Nandurbar",
"Narmada",
"Narayanpet",
"Navi Mumbai",
"Nawada",
"Nellore",
"Neem ka Thana",
"Neemuch",
"Nizamabad",
"Noklak",
"Nongpoh",
"Nongstoin",
"Nongthymmai",
"North 24 Parganas",
"North Delhi",
"North East Delhi",
"North Garo Hills",
"North Goa",
"North Sikkim",
"North West Delhi",
"Nuapada",
"Nuh",
"Nuvem",
"Pakke Kessang",
"Pakur",
"Palakkad",
"Palamu",
"Palghar",
"Panchkula",
"Panchmahal",
"Panchsheel Park",
"Panipat",
"Panna",
"Papum Pare",
"Paramakudi",
"Parbhani",
"Paschim Bardhaman",
"Paschim Medinipur",
"Paschim Vihar",
"Patan",
"Pathanamthitta",
"Patiala",
"Patna",
"Pauri",
"Pehowa",
"Phek",
"Pilibhit",
"Pithoragarh",
"Porbandar",
"Prakasam",
"Pratapgarh",
"Prayagraj",
"Puducherry",
"Pune",
"Puri",
"Purnia",
"Purulia",
"Puttur",
"Puzhathi",
"Raebareli",
"Raigarh",
"Raipur",
"Rajgarh",
"Rajnandgaon",
"Rajsamand",
"Ramgarh",
"Rampur",
"Ranchi",
"Ranipet",
"Ratlam",
"Ratnagiri",
"Rewa",
"Rewari",
"Ri Bhoi",
"Raisen",
"Rajanna Sircilla",
"Ramanagara",
"Ramanathapuram",
"Ramgarh",
"Rampur",
"Rangareddy",
"Ratlam",
"Ratnagiri",
"Reasi",
"Rewa",
"Rewari",
"Rohtak",
"Rohtas",
"Rudraprayag",
"Rupnagar",
"Sabarkantha",
"Sagar",
"Saharanpur",
"Saharsa",
"Sahibganj",
"Saiha",
"Saitual",
"Sakti",
"Salem",
"Salumbar",
"Samba",
"Samastipur",
"Sambalpur",
"Sanchore",
"Sangli",
"Sangrur",
"Sankarankovil",
"Sant Kabir Nagar",
"Santacruz",
"Sarangarh Bilaigarh",
"Saraswati Vihar",
"Sariska",
"Saran",
"Sarangarh Bilaigarh",
"Shahdara",
"Shahjahanpur",
"Shamli",
"Shamshabad",
"Shani Shingnapur",
"Sheikhpura",
"Sheohar",
"Shillong",
"Shimla",
"Shimoga",
"Shivpuri",
"Siddharthnagar",
"Sidhi",
"Sikar",
"Siliguri",
"Simdega",
"Sindhudurg",
"Singrauli",
"Sirohi",
"Sirsa",
"Sitamarhi",
"Sivasagar",
"Sivaganga",
"Srikakulam",
"Srinagar",
"Sukma",
"Suryapet",
"Surajpur",
"Surendranagar",
"Surguja",
"Tapi",
"Tarn Taran",
"Tawang",
"Tehri",
"Tenkasi",
"Thane",
"Thiruvananthapuram",
"Thoothukudi",
"Tikamgarh",
"Tinsukia",
"Tirap",
"Tiruchirappalli",
"Tirunelveli",
"Tirupattur",
"Tiruppur",
"Tiruvallur",
"Tiruvannamalai",
"Tiruvarur",
"Tonk",
"Tumkur",
"Udaipur",
"Udalguri",
"Udhampur",
"Ujjain",
"Ukhrul",
"Una",
"Unakoti",
"Uttara Kannada",
"Uttar Dinajpur",
"Vadodara",
"Valsad",
"Varanasi",
"Vellore",
"Vidisha",
"Vijayanagara",
"Vijayapura",
"Virudhunagar",
"Visakhapatnam",
"Vizianagaram",
"Wanaparthy",
"Warangal",
"Washim",
"Wayanad",
"West Champaran",
"West Delhi",
"West Garo Hills",
"West Godavari",
"West Jaintia Hills",
"West Kameng",
"West Karbi Anglong",
"West Khasi Hills",
"West Siang",
"West Sikkim",
"West Singhbhum",
"West Tripura",
"Yadadri Bhuvanagiri",
"Yamunanagar",
"Yanam",
"Yavatmal",
"Zunheboto"
]


// export const indian_states = indian_state.slice().sort();
export const artTypeData = [
  "Classical",
 "folk",
 "fusion", 
"any other"
]


export const disabilitiesArray = [
  "Mobility Impairments",
  "Visual Impairments",
  "Hearing Impairments",
  "Deafblindness",
  "Intellectual Disabilities",
  "Autism Spectrum Disorder",
  "Speech and Language Impairments",
  "Learning Disabilities",
  "Cognitive Impairments",
  "Attention-Deficit/Hyperactivity Disorder (ADHD)",
  "Mental Health Disabilities",
  "Epilepsy",
  "Cerebral Palsy",
  "Down Syndrome",
  "Muscular Dystrophy",
  "Spina Bifida",
  "Traumatic Brain Injury (TBI)",
  "Chronic Pain",
  "Post-Traumatic Stress Disorder (PTSD)",
  "Multiple Sclerosis",
  "Rheumatoid Arthritis"
];

// Output the disabilities array
console.log(disabilitiesArray);


export const categories = [
  "Artist",
  "Agriculture",
  "Business",
  "Job - Government",
  "Job - Private",
  "Traditional Livelihood",
  "Wage Labour",
  "Any other"
];









































